import { render, staticRenderFns } from "./MultipleLocationSelector.vue?vue&type=template&id=5810bc36"
import script from "./MultipleLocationSelector.vue?vue&type=script&lang=js"
export * from "./MultipleLocationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports